import { render } from "./AdministratorCourseContent.vue?vue&type=template&id=27db4d17"
import script from "./AdministratorCourseContent.vue?vue&type=script&lang=js"
export * from "./AdministratorCourseContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__